import React from "react";
import { MODEL_KEY } from "config/products";
import WatchUltra4Detail from "./WatchUltra4Detail";

function Watch12Gps() {
  return <WatchUltra4Detail modelId={MODEL_KEY.WATCHSERIES12GPS} />;
}

export default Watch12Gps;
